import React  from 'react';
import Skills_Rectangles from "../components/Skills_Rectangles";
function Skills() {

    return (
        <body className="Body-Class">
            <div className="all-project-div">
                <Skills_Rectangles/>
            </div>
        </body>
    );

}

export default Skills;